define('controllers/mysetting/mod-invoice.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('ModInvoiceCtrl', ['$scope', '$rootScope', '$q', '$state', '$filter', 'auiUpload', 'auiDialog', 'OpenApp', 'UserInfo', 'OpenOther', 'UserInfoPreload', 'invoiceService', 'regionService', 'formValidateService','payService','$rootScope','auiAgreementHelper',
        function ($scope, $rootScope, $q, $state, $filter, auiUpload, auiDialog, OpenApp, UserInfo, OpenOther, UserInfoPreload, invoiceService, regionService, formValidateService, payService,$rootScope2,auiAgreementHelper) {
            // 定义一变量，保存初始化时的 Model.invoice
            var oldInvoice = {};
            // 定义一变量， 记录初始的增值税一般纳税人，默认不选中
            var initGeneralVAT = -1;
            var userReceiptInfo;
            var invoiceToString;
            var documentHref = sysParamCfg.documentHref;
            $scope.proxyReceiptDescribe = ['1. 开给自己公司的发票抬头必须和实名一致，如果要求的发票抬头不是自己公司，请选择开给代理公司。 详询客服<br>',
                '2. 若开给代理公司，代理公司需签署授权委托书。<a class="text-link" href="', documentHref.proxyReceiptDescribe, '" target="_blank">详细信息</a>'].join('');
            $scope.invoiceTitleTips = '发票抬头须与“企业全称” 一致。';
            $scope.invoiceTitleTips2Person = '必须与实名认证名称一致。';
            $scope.taxNumberTips = '如“三证合一”且进行过税号变更，请填写新税号，即“三证合一”的统一社会信用代码。';
            var Model = $scope.Model = {};
            Model.userType = UserInfoPreload.userType;
            Model.invoice = {
                taxpayerCertificate: '',
                taxRegistCertificate: '',
                accountOpeningPermit: '',
                businessLicense: ''
            };
            Model.isShowThreeInOneInput = false; //控制展示三证合一复选框
            Model.isThreeInOne = false; //三证合一复选框默认不勾选
            Model.taxpayerWH = '';
            Model.taxRegistWH = '';
            Model.accountWH = '';
            Model.busLicenseWH = '';
            Model.isLegal = AUI.HDGWCall.getCookieOrSessionSt("x-teamId") ? $scope.isLegal : true; //判断是否法务角色
            Model.signList = [];
            Model.agrType1010 = 1010;
            Model.agrType1240 = 1240;
            Model.sign1010 = false;
            Model.sign1240 = false;
            Model.agreementName1010 = '';
            Model.agreementName1240 = '';
            Model.submitInvoiceForm = submitInvoiceForm;
            Model.showSignTip = false;

            Model.serviceStateMsg = '';
            Model.invoiceTitleInputIsDisabled = true;    // 发票抬头

            Model.proxyCompanyBankAccountNullErrorShow = false;
            Model.invoice.country = {
                'key': '',
                'value': ''
            };
            Model.invoice.province = {
                'key': '',
                'value': ''
            };
            Model.invoice.city = {
                'key': '',
                'value': ''
            };
            Model.invoice.invoiceTitle = "";
            //发票资质默认展示三个证书
            $scope.isNormalPer = true;
            Model.corpName = UserInfoPreload.realName;
            $rootScope.checkState($state).then(function () {
                UserInfo.updateCache(init);
            });
            $scope.downLoadAgreement = downLoadAgreement;


            Model.isGeneralVATChange = function () {
                $scope.isNormalPer = true;
                Model.isGeneralVAT = true;
                Model.notGeneralVAT = false;
                if (initGeneralVAT != 1) {
                    Model.invoiceSubmbIsGray = false;
                } else {
                    if (JSON.stringify(Model.invoice) === JSON.stringify(oldInvoice)) {
                        Model.invoiceSubmbIsGray = true;
                    } else {
                        Model.invoiceSubmbIsGray = false;
                    }
                }
                initGeneralVAT = 1;
            };

            Model.notGeneralVATChange = function () {
                $scope.isNormalPer = false;
                Model.isGeneralVAT = false;
                Model.notGeneralVAT = true;
                if (initGeneralVAT != 0) {
                     Model.invoiceSubmbIsGray = false;
                } else {
                    if (JSON.stringify(Model.invoice) === JSON.stringify(oldInvoice)) {
                        Model.invoiceSubmbIsGray = true;
                    } else {
                        Model.invoiceSubmbIsGray = false;
                    }
                }
                initGeneralVAT = 0;
            };

            //下载协议
            function downLoadAgreement() {
                auiAgreementHelper.viewAndDownloadAgreements([Model.agrType1010,Model.agrType1240]);
            }

            Model.showAgreement = function (typeList) {
                var defer = $q.defer();
                auiAgreementHelper.viewAndDownloadAgreements([typeList]).then(function () {
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            Model.merchantServiceSelect = function (selected) {
                Model.showSignTip = true;
                if (Model.isAudting) return;
                Model[selected] = !Model[selected];
                if(Model['isSigned1240'] || Model['isSigned1010']){
                    greenSubmit();
                }else {
                    graySubmit()
                }

            }

            Model.changeProvince = function (province) {
                if (province) {
                    //Model.cities = regionService.setCity(province)
                    //Model.invoice.city = Model.cities[0]
                    // 城市目前需要通过接口获取到数据后进行映射
                    regionService.setCity(province, function (data) {
                        Model.cities = data;
                        Model.invoice.city = Model.cities[0];
                    });
                }
            };

            // 提交按钮灰化
            function graySubmit() {
                Model.invoiceSubmbIsGray = true;
                Model.submitInvoiceForm = function () {}
            }

            // 提交按钮亮化
            function greenSubmit() {
                Model.invoiceSubmbIsGray = false;
                Model.submitInvoiceForm = submitInvoiceForm;
            }

            Model.uploadTaxpayerCertificate = function (files, options, $event) {
                upload2openUP(files, options, 'taxpayerCertificate', 'taxpayerWH');
            };

            Model.uploadTaxRegistCertificate = function () {
                auiDialog.warn("营业执照提醒","如您需要更新企业营业执照，请勾选“营业执照（三证合一）”复选框后，在营业执照上传处上传证件。")
            };

            Model.uploadBusinessLicense = function (files, options) {
                upload2openUP(files, options, 'businessLicense', 'busLicenseWH');
            };


            function upload2openUP(files, options, img, imgWH) {
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    if (fileUrl) {
                        switch (img) {
                            case 'taxpayerCertificate' :
                                Model.invoice.taxpayerCertificate = fileUrl;
                                break;
                            case 'taxRegistCertificate' :
                                Model.invoice.taxRegistCertificate = fileUrl;
                                break;
                            case 'accountOpeningPermit' :
                                Model.invoice.accountOpeningPermit = fileUrl;
                                break;
                            case 'businessLicense' :
                                Model.invoice.businessLicense = fileUrl;
                        }
                        AUI.HTMLUtil.drawImage(180, 120, fileUrl, function (wh) {
                            $scope.$apply(function () {
                                switch (imgWH) {
                                    case 'taxpayerWH' :
                                        Model.taxpayerWH = wh;
                                        break;
                                    case 'taxRegistWH' :
                                        Model.taxRegistWH = wh;
                                        break;
                                    case 'accountWH' :
                                        Model.accountWH = wh;
                                        break;
                                    case 'busLicenseWH' :
                                        Model.busLicenseWH = wh;
                                }
                            });
                        });
                    }
                });
            }

            function submitInvoiceForm(isValid) {
                var defer = $q.defer();
                if (Model.invoiceSubmbIsGray) {
                    defer.reject();
                    return defer.promise;
                }


                if (!Model.sign1010 && !Model.isSigned1010 && !Model.sign1240 && !Model.isSigned1240) {
                    Model.showSignTip = true;
                }

                if (!isValid) {
                    formValidateService.validateForm($scope.invoiceForm);
                    defer.reject();
                    return defer.promise;
                }
                var signNum = 0;
                var signTotal = 0;
                if (!Model.sign1010 || !Model.sign1240) {
                    if (!Model.sign1010 && Model.isSigned1010) {
                        signTotal ++ ;
                        auiAgreementHelper.signAgreement({
                            agrType: Model.agrType1010,
                            version: Model.agreementVersions1010,
                            language: 'zh_CN'
                        }).then(function (signAgreementResult) {
                            if (signAgreementResult) {
                                signNum ++;
                                isHandleSubmit(signNum, signTotal).then(function () {
                                    defer.resolve();
                                }).catch(function () {
                                    defer.reject();
                                });
                            } else {
                                auiDialog.fail('协议签署失败，请联系客服');
                                defer.reject();
                            }
                        });
                    } else if (!Model.sign1240 && Model.isSigned1240) {
                        signTotal ++ ;
                        auiAgreementHelper.signAgreement({
                            agrType: Model.agrType1240,
                            version: Model.agreementVersions1240,
                            language: 'zh_CN'
                        }).then(function (signAgreementResult) {
                            if (signAgreementResult) {
                                signNum ++;
                                isHandleSubmit(signNum, signTotal).then(function () {
                                    defer.resolve();
                                }).catch(function () {
                                    defer.reject();
                                });
                            } else {
                                auiDialog.fail('协议签署失败，请联系客服');
                                defer.reject();
                            }
                        });
                    } else if (Model.sign1240 || Model.sign1010) {
                        isHandleSubmit(signNum, signTotal).then(function () {
                            defer.resolve();
                        }).catch(function () {
                            defer.reject();
                        });
                    } else {
                        defer.reject();
                    }
                } else {
                    handleSubmit().then(function () {
                        defer.resolve();
                    }).catch(function () {
                        defer.reject();
                    });
                }
                return defer.promise;
            }
            function isHandleSubmit(signNum, signTotal){
                var defer = $q.defer();
                if (signNum == signTotal ) {
                    handleSubmit().then(function () {
                        defer.resolve();
                    }).catch(function () {
                        defer.reject();
                    });
                }
                return defer.promise;
            }

            function handleSubmit() {
                if (Model.invoice.invoiceTitle != UserInfoPreload.realName) {
                    auiDialog.fail('发票抬头须与“企业全称” 一致。');
                    return;
                }

                var defer = $q.defer();
                saveReceipt().then(function () {
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }


            Model.cancel = function () {
                //我的账户，余额 弹框显示的发票信息
                if ($scope.balance) {
                    $scope.closeInvoice();
                }
                else {
                    $state.go('mysetting.payService.modInvoice', {}, {reload: true});
                }
            };


            function saveReceipt() {
                var defer = $q.defer();
                var receipt = {};
                var userTaxInfo = angular.copy(Model.userTaxInfo) || {};
                if (userTaxInfo) {
                    delete userTaxInfo.userID;
                }
                receipt.isForCp = 1;
                receipt.title = Model.invoice.invoiceTitle;
                receipt.accountEmail = Model.invoice.accountEmail;
                receipt.contactName = Model.invoice.postContact; // 邮寄联系人姓名  maxlength="20"
                receipt.cellPhone = Model.invoice.postPhone; // 邮寄联系人手机号码  maxlength="32"
                receipt.userID = UserInfoPreload.id; // 用户ID,接口迁移到openUP后新增
                if (Model.userType != 1) {
                    receipt.countryAlpha2Code = Model.invoice.country.key; // 国家
                    receipt.provinceName = Model.invoice.province.key; // 省
                    receipt.cityName = Model.invoice.city.key; // 城市
                    receipt.location = Model.invoice.detailedAddress; // 详细地址  maxlength="200"
                    receipt.postCode = Model.invoice.postCode ? Model.invoice.postCode : ''; // 邮编 maxlength="6"
                    receipt.fixPhone = '';
                    if (Model.invoice.areaCode) {
                        receipt.fixPhone += Model.invoice.areaCode;
                    }
                    if (Model.invoice.phoneNumber && receipt.fixPhone) {
                        receipt.fixPhone += '-' + Model.invoice.phoneNumber;
                    }
                    if (Model.invoice.phoneNumber && !receipt.fixPhone) {
                        receipt.fixPhone += Model.invoice.phoneNumber;
                    }
                    if (Model.invoice.extensionNumber && receipt.fixPhone) {
                        receipt.fixPhone += '-' + Model.invoice.extensionNumber;
                    }

                    if (Model.invoice.extensionNumber && !receipt.fixPhone) {
                        receipt.fixPhone += Model.invoice.extensionNumber;
                    }
                    //如果不是一般纳税人 则传空值
                    if (Model.notGeneralVAT) {
                        receipt.imgUrl = "";
                    } else {
                        receipt.imgUrl = Model.invoice.taxpayerCertificate; // 一般纳税人资格证书
                    }
                    receipt.imgUrl2 = Model.invoice.taxRegistCertificate; // 税务登记证
                    receipt.imgUrl3 = Model.invoice.accountOpeningPermit; // 开户许可证
                    receipt.threeInOneUrl = Model.invoice.businessLicense?Model.invoice.businessLicense:''; //营业执照（三证合一）

                    receipt.registerPhone = Model.invoice.proxyCompanyRegPhone; // 代理公司注册电话 maxlength="32"
                    receipt.bankName = Model.invoice.proxyCompanyBank;// 代理公司开户行 maxlength="50"
                    receipt.bankAccount = Model.invoice.proxyCompanyBankAccount == Model.proxyCompanyBankAccountFuzzy?Model.oldProxyCompanyBankAccount:Model.invoice.proxyCompanyBankAccount;// 代理公司银行帐号 maxlength="32"
                    receipt.loginName = UserInfoPreload.loginName;
                    //receipt.accountEmail = UserInfoPreload.contactEmail

                    // 封装userTaxInfo
                    userTaxInfo.taxNum = Model.invoice.proxyCompanyTaxNumber; // 代理公司税号 maxlength="32"
                    userTaxInfo.taxCountry = "CN";
                    userTaxInfo.registerAddress = Model.invoice.proxyCompanyRegAddress; // 代理公司注册地址 maxlength="200"
                    userTaxInfo.generalVAT = Model.isGeneralVAT ? 1 : 0; // 是否增值税纳税人，1:yes0:no
                }

                req = {
                    'type': Model.type,
                    'receipt': receipt,
                    'userTaxInfo': userTaxInfo
                }
                var fun = 'createReceiptForIndiv';
                if (Model.userType != 1) {
                    fun = 'createReceipt';
                }
                invoiceService[fun]({
                    "req": {
                        'type': Model.type,
                        'receipt': receipt,
                        'userTaxInfo': userTaxInfo
                    }
                }, function (data) {
                    if (data.userID) {
                        var succContent ='您还可以通过'+'<a class="text-link" target="_blank" href="'+systemParaConf.appPromotion.url+'">开发者联盟APP</a>随时查询账单。'
                        auiDialog.success('保存成功。',succContent, function () {
                            UserInfo.updateCache(function () {
                                init();
                                //向父controller传值$scope.value
                                $scope.$emit("changePage", true);
                                $scope.$emit("stateChangedEvent", true);
                            });
                            defer.resolve();
                        });
                        //我的账户，余额 弹框显示的发票信息
                        if ($scope.balance) {
                            $scope.closeInvoice();
                            defer.resolve();
                        }
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            }



            function init() {
                // 查询是否签署过最新协议
                if(UserInfoPreload.verifyRealState != 1){
                    auiAgreementHelper.queryAgreements([Model.agrType1010,Model.agrType1240]).then(function (data) {
                        var agreementToTemplateInfos = [];
                        Model.agreementVersions1010 = data.signInfoList[0].latestVersion;
                        Model.agreementVersions1240 = data.signInfoList[1].latestVersion;
                        Model.agrType1010 = data.signInfoList[0].agrType;
                        Model.agrType1240 = data.signInfoList[1].agrType;
                        if (data.signInfoList[0].signStatus == 1 || data.signInfoList[0].signStatus == 2) {//是否已经签署付费服务协议
                            Model.sign1010 = true;
                            Model.isSigned1010 = true;
                            Model.signList.push(Model.agrType1010);
                        } else {
                            Model.isSigned1010 = false;
                        }
                        if (data.signInfoList[1].signStatus == 1 || data.signInfoList[1].signStatus == 2) {
                            Model.sign1240 = true;
                            Model.isSigned1240 = true;
                            Model.signList.push(Model.agrType1240);
                        } else {
                            Model.isSigned1240 = false;
                        }
                        for (var i in data.signInfoList) {
                            agreementToTemplateInfos.push({
                                agrType: data.signInfoList[i].agrType,
                                latestVersion: data.signInfoList[i].latestVersion
                            });
                        }
                        if (agreementToTemplateInfos.length > 0) {
                            auiAgreementHelper.agreementToTemplateInfo(agreementToTemplateInfos).then(function (templateInfoListResult) {
                                if (templateInfoListResult && templateInfoListResult.templateInfoList && templateInfoListResult.templateInfoList.length > 0) {
                                    for (var i in templateInfoListResult.templateInfoList) {
                                        var n = Number(i);
                                        if (templateInfoListResult.templateInfoList[n].agrType == Model.agrType1010) {
                                            Model.notSignAgreeUrl1010 = templateInfoListResult.templateInfoList[n].url;
                                            Model.agreementName1010 = templateInfoListResult.templateInfoList[n].agrName;
                                        }
                                        if (templateInfoListResult.templateInfoList[n].agrType == Model.agrType1240) {
                                            Model.notSignAgreeUrl1240 = templateInfoListResult.templateInfoList[n].url;
                                            Model.agreementName1240 = templateInfoListResult.templateInfoList[n].agrName;
                                        }
                                    }
                                }
                                payTip();
                            })
                        }
                    })
                }
                if (UserInfoPreload.verifyRealState == 1) {
                    auiDialog.warn('您的实名认证资料在审核中，请审核通过后再设置付费信息。', function () {
                        $rootScope.toSettingUserInfo();
                    });
                } else {
                    Model.invoiceSubmbIsGray = true;
                    regionService.setProvince(function (data) {
                        Model.provinces = data;
                        Model.countrys = [{'key': 'CN', 'value': '中国'}];
                        invoiceService.getInvoiceInfo(function (data) {
                            var agreeType = 0;
                            Model.invoice.invoiceTitle = UserInfoPreload.realName;  // 发票抬头
                            if (data && data.userTaxInfo) {
                                var userTaxInfo = data.userTaxInfo;
                                Model.userTaxInfo = angular.copy(userTaxInfo);
                                if (userTaxInfo.generalVAT == '1') {  // 是否增值税纳税人，1:yes 0:no
                                    initGeneralVAT = 1;
                                    Model.isGeneralVAT = true;
                                    Model.notGeneralVAT = false;
                                } else if (userTaxInfo.generalVAT == '0') {  // 是否增值税纳税人，1:yes0:no
                                    initGeneralVAT = 0;
                                    Model.isGeneralVAT = false;
                                    Model.notGeneralVAT = true;
                                }
                                Model.invoice.proxyCompanyRegAddress = userTaxInfo.registerAddress;  // 代理公司注册地址
                                Model.invoice.proxyCompanyTaxNumber = userTaxInfo.taxNum;  // 代理公司税号
                            }
                            if (data && data.receipt) {
                                var receipt = data.receipt;
                                if (receipt.title) {
                                    Model.invoice.invoiceTitle = receipt.title;
                                    if (receipt.title != UserInfoPreload.realName) {
                                        Model.invoiceTitleInputIsDisabled = false;
                                    }
                                }
                                if(UserInfoPreload.userType != 1){
                                    // 城市目前需要通过接口获取到数据后进行映射
                                    regionService.setCity(receipt.provinceName, function (data) {
                                        Model.cities = data;
                                        Model.invoice.city.key = receipt.cityName;  // 城市
                                        Model.invoice.city.value = regionService.getCityFromList(receipt.cityName, Model.cities);  // 城市

                                        Model.historyOrder = true;
                                        Model.type = "1";  // 1 代表按钮修改

                                        invoiceToString = angular.toJson(angular.copy(receipt));
                                        if (receipt.country) {
                                            Model.invoice.country.key = receipt.countryAlpha2Code;  // 国家
                                            Model.invoice.country.value = receipt.country;
                                        } else {
                                            Model.invoice.country = Model.countrys[0];  // 国家
                                        }
                                        Model.invoice.province.key = receipt.provinceName;  // 省
                                        Model.invoice.province.value = regionService.getProvinceFromList(receipt.provinceName, Model.provinces);  // 省
                                        Model.invoice.proxyCompanyRegPhone = receipt.registerPhone;  // 代理公司注册电话
                                        Model.invoice.proxyCompanyBank = receipt.bankName;  // 代理公司开户行
                                        Model.invoice.proxyCompanyBankAccount = receipt.bankAccount;  // 代理公司银行帐号
                                    });
                                }
                                // 如果receipt中无accountEmail（新增情况）
                                if (!receipt.accountEmail) {
                                    //发票寄送Email默认从商户服务财务联系人的email
                                    getContactInfo();
                                    // 如果没有，则取实名认证中的联系人email
                                    if (!Model.invoice.accountEmail) {
                                        Model.invoice.accountEmail = UserInfoPreload.contactEmail;
                                    }
                                } else {
                                    Model.invoice.accountEmail = receipt.accountEmail;
                                }

                                Model.invoice.detailedAddress = receipt.location;  // 详细地址
                                Model.invoice.postCode = receipt.postCode;  // 邮编
                                Model.invoice.postContact = receipt.contactName;  // 邮寄联系人姓名
                                Model.invoice.postPhone = receipt.cellPhone;  // 邮寄联系人手机号码
                                if (receipt.fixPhone) {
                                    var fexPhone = receipt.fixPhone.split('-');  // 电话号码
                                    if (fexPhone.length == 1) {
                                        Model.invoice.phoneNumber = fexPhone[0];
                                    } else if (fexPhone.length == 2) {
                                        if (fexPhone[0].length > 4) {
                                            Model.invoice.phoneNumber = fexPhone[0];
                                            Model.invoice.extensionNumber = fexPhone[1];
                                        } else {
                                            Model.invoice.areaCode = fexPhone[0];
                                            Model.invoice.phoneNumber = fexPhone[1];
                                        }
                                    } else if (fexPhone.length == 3) {
                                        Model.invoice.areaCode = fexPhone[0];  // 区号
                                        Model.invoice.phoneNumber = fexPhone[1];  // 电话号码
                                        Model.invoice.extensionNumber = fexPhone[2];  // 分机号
                                    }
                                }


                                Model.invoice.taxpayerCertificate = receipt.imgUrl;  // 一般纳税人资格证书
                                //初始化查询  判断状态
                                if (Model.isGeneralVAT) {//如果是一般纳税人 显示第一条
                                    $scope.isNormalPer = true;
                                } else if (Model.notGeneralVAT && receipt.imgUrl != "") {//不是一般纳税人 但是第一条有老数据 仍然显示第一条
                                    $scope.isNormalPer = true;
                                } else if (Model.notGeneralVAT && receipt.imgUrl == "") {//隐藏第一条
                                    $scope.isNormalPer = false;
                                }

                                AUI.HTMLUtil.drawImage(180, 120, receipt.imgUrl, function (wh) {
                                    $scope.$apply(function () {
                                        Model.taxpayerWH = wh;
                                    });
                                });
                                if((!receipt.imgUrl2 && !receipt.imgUrl3 && !receipt.threeInOneUrl) || receipt.threeInOneUrl){//三者都不存在则为新用户，threeInOneUrl存在则证明用户维护过三证合一证件，这两种情况都不需要展示三证合一的复选框
                                    Model.isShowThreeInOneInput = false;
                                    Model.isThreeInOne = true;
                                }else if(receipt.imgUrl2 && receipt.imgUrl3 && !receipt.threeInOneUrl){//前两者存在并且三证合一证件照不存在，表示为存量没有提交过三证合一的场景，需展示三证合一复选框
                                    Model.isShowThreeInOneInput = true;
                                    Model.isThreeInOne = false;
                                }
                                Model.invoice.taxRegistCertificate = receipt.imgUrl2;  // 税务登记证
                                AUI.HTMLUtil.drawImage(180, 120, receipt.imgUrl2, function (wh) {
                                    $scope.$apply(function () {
                                        Model.taxRegistWH = wh;
                                    });
                                });
                                Model.invoice.accountOpeningPermit = receipt.imgUrl3;  // 开户许可证
                                AUI.HTMLUtil.drawImage(180, 120, receipt.imgUrl3, function (wh) {
                                    $scope.$apply(function () {
                                        Model.accountWH = wh;
                                    });
                                });
                                Model.invoice.businessLicense = receipt.threeInOneUrl;
                                AUI.HTMLUtil.drawImage(180, 120, receipt.threeInOneUrl, function (wh) {
                                    $scope.$apply(function () {
                                        Model.busLicenseWH = wh;
                                    });
                                })

                                //如果我的余额页面展示发票信息，不需要展示历史订单链接
                                if ($scope.balance) {
                                    Model.historyOrder = false;
                                }
                                agreeType = receipt.isForCp;
                                userReceiptInfo = receipt;
                                if(Model.invoice.proxyCompanyBankAccount){
                                    Model.oldProxyCompanyBankAccount = angular.copy(Model.invoice.proxyCompanyBankAccount);
                                    Model.invoice.proxyCompanyBankAccount = formValidateService.hiddenInfo(Model.invoice.proxyCompanyBankAccount,0,4);
                                    Model.proxyCompanyBankAccountFuzzy = angular.copy(Model.invoice.proxyCompanyBankAccount);
                                }
                                oldInvoice = angular.copy(Model.invoice);
                                agreeType = 1;


                            } else if (data && data.resultCode === 0) {
                                getContactInfo();
                                Model.isGeneralVAT = null;
                                Model.isThreeInOne = true;//没有获取到税务信息证明是新注册用户，则默认为三证合一
                                // 如果没有，则取实名认证中的联系人email
                                if (!Model.invoice.accountEmail) {
                                    Model.invoice.accountEmail = UserInfoPreload.contactEmail;
                                }
                                Model.historyOrder = false;
                                Model.type = "0";  // 0 代表按钮新增
                                Model.invoice.country = Model.countrys[0];  // 国家
                                agreeType = 1;
                            }

                        });

                    });
                }
            }
            function payTip (){
                if (!Model.sign1010 && !Model.sign1240 && !Model.isLegal) {
                    auiAgreementHelper.showNeedSignDia4CNPayAgreement(UserInfoPreload.contactEmail, function () {
                        $state.go('home', {}, {reload: true})
                    },[Model.agreementName1010,Model.agreementName1240])
                }
            }

            Model.chooseThree2one = function () {
                Model.isThreeInOne = !Model.isThreeInOne
            }

            function getContactInfo() {
                //发票寄送Email默认从商户服务财务联系人的email
                invoiceService.getContactInfo(function (contactInfo) {
                    var contactInfoFlag = true;
                    angular.forEach(contactInfo, function (contacter) {
                        // 商户服务财务联系人role位finance
                        if (contactInfoFlag && contacter && contacter.role == 'finance' && contacter.contactMeta.email != '') {
                            Model.invoice.accountEmail = contacter.contactMeta.email;
                            contactInfoFlag = false;
                        }
                    });
                });
            }

            Model.proxyCompanyBankAccountKeyup = function(){
            	 // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
            	if(Model.oldProxyCompanyBankAccount){
            		if (Model.oldProxyCompanyBankAccount != Model.invoice.proxyCompanyBankAccount && Model.proxyCompanyBankAccountFuzzy  != Model.invoice.proxyCompanyBankAccount) {
                    	if(!formValidateService.testBankAccout(Model.invoice.proxyCompanyBankAccount)){
                    		Model.proxyCompanyBankAccountNullErrorShow = true;
                    		return;
                    	}
                    }
            	}else{
            		if(!formValidateService.testBankAccout(Model.invoice.proxyCompanyBankAccount)){
            			Model.proxyCompanyBankAccountNullErrorShow = true;
                		return;
                	}
            	}

            	Model.proxyCompanyBankAccountNullErrorShow = false;
            }

            $scope.$watch("Model.invoice", function (newValue, oldValue) {
                if (JSON.stringify(newValue) === JSON.stringify(oldInvoice)) {
                    Model.invoiceSubmbIsGray = true;
                }
                else {
                    Model.invoiceSubmbIsGray = false;
                }

                if (Model.userType != 1) {
                    if(Model.isSigned1240 || Model.isSigned1010) {
                        Model.invoiceSubmbIsGray = false;
                    }
                    if (initGeneralVAT == 1 && Model.notGeneralVAT == true) {
                        Model.invoiceSubmbIsGray = false;
                    } else if (initGeneralVAT == 0 && Model.isGeneralVAT == true) {
                        Model.invoiceSubmbIsGray = false;
                    }

                    if ($scope.isNormalPer && (!Model.invoice.taxpayerCertificate || Model.invoice.taxpayerCertificate == '')) {
                        Model.invoiceSubmbIsGray = true;
                    }
                    if (!Model.isThreeInOne && (!Model.invoice.taxRegistCertificate || Model.invoice.taxRegistCertificate == '')) {
                        Model.invoiceSubmbIsGray = true;
                    }
                    if (!Model.isThreeInOne && (!Model.invoice.accountOpeningPermit || Model.invoice.accountOpeningPermit == '')) {
                        Model.invoiceSubmbIsGray = true;
                    }
                    if (Model.isThreeInOne && (!Model.invoice.businessLicense || Model.invoice.businessLicense == '')) {
                        Model.invoiceSubmbIsGray = true;
                    }
                    if (Model.proxyCompanyBankAccountNullErrorShow) {
                        Model.invoiceSubmbIsGray = true;
                    }
                }

            }, true);

        }]);
});

